import Title from '@/components/Title'
import TextBody from '@/components/TextBody/TextBody'

import s from './VideoTestimonials.module.scss'
import { HTMLAttributes } from 'react'

const videos = [
  {
    id: 'S217kXTrHkX6yELnpPo6',
    src: 'https://storyprompt.com/watch/story/xkg1XkFFJ0dfr86W0qXN?oembed=1&autoplay=0',
  },
  {
    id: 'bxtcePBGzJNQ2TiY37xN',
    src: 'https://storyprompt.com/watch/story/0uLn3rFiKEKtsJdyS2Sr?oembed=1&autoplay=0',
  },
]

interface IVideoTestimonials extends HTMLAttributes<HTMLElement> {}

export default function VideoTestimonials(props: IVideoTestimonials) {
  return (
    <section {...props}>
      <div className={s.videoTestimonials}>
        <div className={s.copy}>
          <Title variant="h1-small">Video Testimonials</Title>
          <TextBody size="l">
            Watch our pet parents share their Mawoo experience!
          </TextBody>
        </div>

        <div className={s.videos}>
          {videos.map((video) => (
            <div key={video.id} className={s.videoWrapper}>
              <iframe
                src={video.src}
                allow="camera *; microphone *; encrypted-media *; fullscreen *; display-capture *;"
                className={s.video}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
